/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Card, { CardProps } from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import { alpha, styled } from '@mui/material/styles';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { VerticalScroll } from '@qpr/components';
import React, { useState } from 'react';
import ElementList from '../ElementList/components/ElementList';

const PREFIX = 'SearchCard';

const classes = {
  searchInput: `${PREFIX}-searchInput`,
  title: `${PREFIX}-title`,
  listItem: `${PREFIX}-listItem`,
  scroll: `${PREFIX}-scroll`,
  breakWords: `${PREFIX}-breakWords`
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`& .${classes.searchInput}`]: {
    background: theme.palette.grey[300],
    padding: theme.spacing(1),
    borderRadius: 4
  },

  [`& .${classes.title}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: alpha(theme.palette.text.primary, 0.9)
  },

  [`& .${classes.listItem}`]: {
    display: 'unset',
    padding: theme.spacing(1)
  },

  [`& .${classes.scroll}`]: {
    marginTop: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    overflowY: 'auto'
  },

  [`& .${classes.breakWords}`]: {
    wordBreak: 'break-word'
  }
}));

interface SeachCardProps extends React.PropsWithChildren<CardProps> {
  data: Array<{ id: string; name: string }>;
  onClick: any;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: any;
  title: string;
  'data-testid'?: string;
  className?: string;
  icon: React.ElementType<SvgIconProps<'svg', {}>>;
}

const SearchCard = ({
  title,
  data,
  onClick,
  onSearch,
  onClose,
  icon,
  ...cardProps
}: SeachCardProps) => {
  const [isOpen, setIsOpen] = useState<boolean>();

  return (
    <StyledCard {...cardProps}>
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div>
          <div style={{ float: 'right' }}>
            {!isOpen ? (
              <IconButton
                onClick={() => setIsOpen(true)}
                data-testid="open-search-button"
                size="large"
              >
                <SearchIcon />
              </IconButton>
            ) : null}
          </div>
          <Typography
            variant="subtitle1"
            noWrap
            className={classes.title}
            data-testid="search-card-title"
          >
            {title}
          </Typography>
          {isOpen ? (
            <FormControl fullWidth>
              <Input
                data-testid="search-card-input"
                onChange={onSearch}
                className={classes.searchInput}
                disableUnderline
                placeholder="Search"
                id="input-with-icon-adornment"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setIsOpen(false);
                        onClose();
                      }}
                      size="large"
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          ) : null}
        </div>
        <div className={classes.scroll}>
          <VerticalScroll>
            {data.length > 0 ? (
              <ElementList data={data} icon={icon} />
            ) : (
              <Typography variant="body2">No data</Typography>
            )}
          </VerticalScroll>
        </div>
      </div>
    </StyledCard>
  );
};

export default SearchCard;
